export const COMMON = Object.freeze ({
    ROLE_ADMIN: 1, //dialog xac nhan block account
    ROLE_ADMIN_DE: 2, // dialog xac nhan xoa account 
    ROLE_ADMIN_COM: 3, // dialog xac nhan reject account
    ROLE_MANAGEMENT: 4, // dialog reset password
    ROLE_SALE: 5, //popup register

    PACK_TRIAL:  'CUK.TRL',
    PACK_STANDARD: 'CUK.STA',
    PACK_PROFESSIONAL: 'CUK.PRO',
    PACK_ENTERPRISE: 'CUK.ENT',
    PACK_STARTER: 'CUK.STT',
    PACK_ADVANCED: 'CUK.ADV',

    UPGRADE: 1, // Nâng cấp gói
    EXTEND: 2, // gia hạn gói
    PURCHASE: 3, // mua thêm thiết bị
    PURCHASE_LICENSE: 4, // mua gói cho chi nhánh
    AUTO_EXTEND: 5, // gia hạn tự động (hệ thống tạo)

    NEED_APPROVE: 0,
    APPROVED:1,
    REJECT: 2,

    Int : 1, //type integer
    Boolean : 2, // type bool
    String : 3, // string 
    List : 4, // list
    Double : 5, // double
    Date:6
})